import React from "react";

const AppContext = React.createContext({
  screenList: []
});

export default AppContext;
